/**
 * Extracts and capitalizes a user's name from an email address.
 * 
 * Funciton is utilized in the LogFormComponent to format the name of contacts
 * 
 * - Takes the portion of the email before the '@' symbol.
 * - Assumes the name is formatted with periods separating components (e.g., "john.d.doe").
 * - Capitalizes the first letter of each name component while converting the rest to lowercase.
 * - Handles single-character middle initials by converting them to uppercase.
 * - Returns an empty string if input is invalid.
 * 
 * @param email The email address to extract and format the name from.
 * @returns A formatted name with capitalized initials (e.g., "John D Doe") or an empty string if input is invalid.
 */

export function capitalizeNameFromEmail(email:string) {
    if (!email || typeof email !== 'string') {
        return ''; // Return an empty string for invalid input
    }

    // Extract the part of the email before the @
    const namePart = email.split('@')[0];
    
    // Split the name part into components
    const nameComponents = namePart.split('.');

    // Capitalize each component (e.g., first name, middle initial, last name)
    const capitalizedComponents = nameComponents.map(component => {
        if (component.length === 1) {
            // Handle single-character middle initials
            return component.toUpperCase();
        }
        return component.charAt(0).toUpperCase() + component.slice(1).toLowerCase();
    });


    // Join the components back into a single string
    return capitalizedComponents.join(' ');
}

